import { useState } from 'react';

export default function AuthModal({ open, onClose }) {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    // In production this would call the auth API
    setTimeout(() => {
      setMessage(mode === 'login' ? 'Login functionality ready — connect to backend API' : 'Registration ready — connect to backend API');
      setLoading(false);
    }, 800);
  };

  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: 12,
    border: '1.5px solid rgba(74,124,89,0.15)', background: '#FFFEF9',
    fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: '#2D3B2D',
    outline: 'none', transition: 'border-color 0.3s',
  };

  return (
    <>
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
        backdropFilter: 'blur(4px)', zIndex: 3000,
      }} />
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%', maxWidth: 420, background: '#FFFEF9',
        borderRadius: 20, zIndex: 3001, overflow: 'hidden',
        boxShadow: '0 32px 64px rgba(0,0,0,0.2)',
        animation: 'scaleIn 0.3s ease-out',
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #2D5A3F, #1E3F2B)',
          padding: '28px 28px 24px', textAlign: 'center',
        }}>
          <span style={{ fontSize: 32 }}>🌿</span>
          <h2 style={{
            fontFamily: "'Playfair Display', serif", fontSize: 24, fontWeight: 700,
            color: '#E8E0CC', marginTop: 8,
          }}>{mode === 'login' ? 'Welcome Back' : 'Join Gramaayam'}</h2>
          <p style={{ fontSize: 13, color: '#A8B89C', marginTop: 6 }}>
            {mode === 'login' ? 'Sign in to your account' : 'Create your account for organic goodness'}
          </p>
          <button onClick={onClose} style={{
            position: 'absolute', top: 16, right: 16, background: 'none',
            border: 'none', color: '#A8B89C', fontSize: 20,
          }}>✕</button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ padding: '24px 28px 28px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {mode === 'register' && (
              <input
                type="text" placeholder="Full Name" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                style={inputStyle} required
              />
            )}
            <input
              type="email" placeholder="Email Address" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              style={inputStyle} required
            />
            {mode === 'register' && (
              <input
                type="tel" placeholder="Phone Number" value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                style={inputStyle}
              />
            )}
            <input
              type="password" placeholder="Password" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              style={inputStyle} required minLength={8}
            />
          </div>

          {message && (
            <p style={{
              fontSize: 13, color: '#4A7C59', marginTop: 12, padding: '8px 12px',
              background: 'rgba(74,124,89,0.08)', borderRadius: 8, textAlign: 'center',
            }}>{message}</p>
          )}

          <button type="submit" className="btn btn-primary" disabled={loading} style={{
            width: '100%', marginTop: 18, padding: 14, fontSize: 15,
            opacity: loading ? 0.7 : 1,
          }}>
            {loading ? '...' : mode === 'login' ? 'Sign In' : 'Create Account'}
          </button>

          <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#7A8B6F' }}>
            {mode === 'login' ? "Don't have an account? " : 'Already have an account? '}
            <button
              type="button"
              onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setMessage(''); }}
              style={{
                background: 'none', border: 'none', color: '#2D5A3F',
                fontWeight: 600, fontSize: 13, textDecoration: 'underline',
              }}
            >
              {mode === 'login' ? 'Sign Up' : 'Sign In'}
            </button>
          </p>
        </form>
      </div>
    </>
  );
}
